<template>
  <div class="bg-white shadow-sm">
    <b-navbar toggleable="lg" variant="faded" type="light">
      <b-navbar-brand>
        <router-link tag="div" :to="{name: 'dashboard'}" class="logoHolder">
          <img class="d-none d-md-block" style="height: 40px" :src="logo" alt="LOGO"/>
          <img class="d-block d-md-none" style="height: 40px" :src="logo_mini" alt="LOGO"/>
        </router-link>
      </b-navbar-brand>

      <!-- Right aligned nav items -->
      <div class="ml-auto">
        <b-dropdown class="dropdown-menu-right user-info" right variant="empty" menu-class="user-account-settings"
                    no-caret>
          <template slot="button-content">
            <div class="mr-2">
              <span class="font-bold leading-none">{{ user.full_name }}</span>
              <div class="text-right text-sm">parent</div>
            </div>
            <img class="avatar mr-1" :src="user.avatar" alt="profile pic"/>
            <i class="fa fa-caret-down text-green"></i>
          </template>
          <b-dropdown-item active-class="" :href="home_url">
            <i class="ti-home"></i>
            <span>Acceuil</span>
          </b-dropdown-item>
          <b-dropdown-item active-class="" @click="logout">
            <i class="ti-close"></i>
            <span>Se déconnecter</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </b-navbar>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
  data() {
    return {
      isPath: true
    };
  },
  computed: {
    ...mapGetters(['user', 'logo', 'logo_mini']),
    ...mapState(['home_url'])
  },
  methods: {
    logout() {
      window.logout()
    }
  },
  mounted: function () {
    console.log(this.$route.path);

    if (this.$route.path === "/") {
      this.isPath = true;
    }
    if (this.$route.path === "/bars") {
      this.isPath = false;
    }
  }
};
</script>

<style lang="scss">
//@import "../assets/css/tailwind.css";

.logoText {
  font-size: 10px;
  display: flex;
  justify-content: flex-end;
  margin-top: -10px;
  padding-right: 20px;
  margin-right: -30px;
}

.logoHolder {
  width: fit-content;
}

.user-info {

  button {
    display: flex;
    align-items: center;
    padding: 0;
    box-shadow: none !important;
  }

}
</style>
